"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInjector = void 0;
const react_1 = require("react");
const context_1 = require("../context");
/**
 * Custom hook that returns an Injecor instance from the InjectorContext.
 */
const useInjector = () => react_1.useContext(context_1.InjectorContext);
exports.useInjector = useInjector;
//# sourceMappingURL=use-injector.js.map